import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import Snackbar from '@mui/material/Snackbar'
import React, { useState } from 'react'
import { useNotification } from '../context/NotificationContext'

type Props = {
  message: string
  type: string
}

export function Notification({ message, type }: Props): JSX.Element | null {
  const [notiOpen, setNotiOpen] = useState(true)
  const { sendNotification } = useNotification()
  function clearNotification(msg: string) {
    sendNotification({
      message: msg,
      type: 'success'
    })
  }

  if (!message) {
    return null
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      ContentProps={{
        sx: `${type}` !== 'success' ? { background: 'red' } : { background: 'green' },
      }}
      open={notiOpen}
      autoHideDuration={2000}
      onClose={() => {
        clearNotification('')
        return setNotiOpen(false)
      }}
      message={message}
      action={
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              clearNotification('')
              setNotiOpen(false)
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
    />
  )
}
